module.exports = __webpack_public_path__ + "static/media/Gouvernance_PictoCdlT.376810cb.png";